import React, { Component } from "react";

import { CToggler, CHeaderNav } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import HeaderMenu from "./HeaderMenu";
import { toggleMenu, toggleMinimizeMenu } from "../actions/menuActions";
import URL from "../config/api";
import axios from "../config/axios";

import "./styles.css";

const propTypes = {
  children: PropTypes.node
};

const defaultProps = {};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photo: null
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}access/role/getMenuPhoto`, {
        params: {
          school_id: this.props.general.active_roles.school_id,
          group_id: this.props.general.active_roles.group_id
        },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({ photo: resp.data.data });
      });
    if (this.props.user.user_roles) {
      let aux = this.props.user.user_roles.find(
        elem => elem.group_name === "Alagoas"
      );
      // eslint-disable-next-line react/no-unused-state
      this.setState({ isAlagoas: aux });
    }
  }

  render() {
    let userGroup = this.props.general.active_roles.group_id;
    let userType = this.props.general.active_roles.role_id;
    const isAlagoas =
      (userGroup === 49 || userGroup === 86) &&
      userType > 3 &&
      userType !== 6 && // professor
      userType !== 4; // admin escolar
    const isDigitalBooks = userGroup === 71;
    return (
      <>
        {!isAlagoas && !isDigitalBooks && (
          <>
            <CToggler
              inHeader
              className="ml-md-3 d-lg-none"
              onClick={this.props.toggleMenu}
            />
            <CToggler
              inHeader
              className="ml-3 d-md-down-none"
              onClick={this.props.toggleMinimizeMenu}
            />
          </>
        )}
        {this.state.photo && (
          <div className="flex-1 ml-3 my-auto">
            <img
              src={URL.img + this.state.photo}
              alt="logo"
              style={{
                height: "36px",
                maxWidth: "200px",
                objectFit: "contain",
                objectPosition: "left"
              }}
              className="w-100"
            />
          </div>
        )}
        <CHeaderNav className="mr-auto" />
        <input
          type="password"
          style={{ display: "none" }}
          autoComplete="new-password"
        />
        <CHeaderNav className="px-3">
          <HeaderMenu />
        </CHeaderNav>
      </>
    );
  }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const mapStateToProps = state => ({
  user: state.user,
  form: state.form,
  general: state.general,
  note: state.note
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ toggleMenu, toggleMinimizeMenu }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
